// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"55f32243","453":"2279ccd9","562":"fe6155d6","715":"67853e54"}[chunkId] + ".chunk.js";
};